import api from "../../index";

export const AllCurrency = (params) => api.get(`Currency/Get-All-Currency-history?${params}`);
export const AllCurrencySync = (payload) => api.get(`Currency/Get-Currency-Exchange-Sync?${payload}`);
export const AddUpdatUpdateCurrencyApi = (payload) => api.put('Currency/Update-Currency-Rate',payload);
